export const createHostedLinksGuard = store => async (_to, _from, next) => {
  try {
    await store.dispatch('hostedLinks2/loadAccess')
    next()
  } catch (_) {
    next({ path: '/' })
    store.dispatch('show_snackbar', {
      text: 'No se pudo verificar el acceso a Links de Pago 2.', color: 'error'
    })
  }
}
